import React from 'react';
import colorForAttitude from 'util/colorForAttitude';
import transparentizeRGBA from 'util/transparentizeRGBA';
import { LevelIndicator } from 'components/common/level-indicator';
import styled from 'styled-components';

export const LevelOfDiscussion = ({
  description,
  level,
  attitude,
  total = 4,
}) => {
  const color = colorForAttitude(attitude);
  const secondary = transparentizeRGBA(color, 0.25);

  return (
    <StyledLevelOfDiscussion className="level-of-discussion">
      <h4>{description}</h4>
      <LevelIndicator
        total={total}
        level={level}
        color={color}
        secondary={secondary}
      />
    </StyledLevelOfDiscussion>
  );
};

const StyledLevelOfDiscussion = styled.div`
  min-width: 120px;
  flex: 0 1 auto;
  h4 {
    font-family: 'Zilla Slab', serif;
    font-size: 14px;
    margin-bottom: 15px;
  }
`;
